import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DailyRecord } from '@/types/cbs';

interface CBSDailyRecordStore {
  records: DailyRecord[];
  pendingSync: DailyRecord[];
  
  addRecord: (record: DailyRecord) => void;
  updateRecord: (id: string, updates: Partial<DailyRecord>) => void;
  getRecordsForBatch: (batchId: string) => DailyRecord[];
  getTodayRecord: (batchId: string, date: string) => DailyRecord | undefined;
  markSynced: (id: string) => void;
  clearRecords: () => void;
}

export const useCBSDailyRecordStore = create<CBSDailyRecordStore>()(
  persist(
    (set, get) => ({
      records: [],
      pendingSync: [],
      
      addRecord: (record) => set((state) => ({
        records: [record, ...state.records],
        pendingSync: [...state.pendingSync, record],
      })),
      
      updateRecord: (id, updates) => set((state) => ({
        records: state.records.map((r) =>
          r.id === id ? { ...r, ...updates } : r
        ),
      })),
      
      getRecordsForBatch: (batchId) =>
        get().records.filter((r) => r.batch_id === batchId),
      
      getTodayRecord: (batchId, date) =>
        get().records.find(
          (r) => r.batch_id === batchId && r.record_date === date
        ),
      
      markSynced: (id) => set((state) => ({
        pendingSync: state.pendingSync.filter((r) => r.id !== id),
      })),
      
      clearRecords: () => set({ records: [], pendingSync: [] }),
    }),
    { name: 'cbs-daily-record-storage' }
  )
);
